import { v4 as uuid } from 'uuid';
import * as Env from 'widget/env';

const normalizeMessage = (
  content: string,
  name: string,
  userpic: string,
): Env.Message => ({
  content,
  dialog_id: '',
  edited_at: '0001-01-01T00:00:00Z',
  file_url: '',
  id: uuid(),
  quotedMsgId: '',
  reactions: [],
  sender_id: '',
  sender_name: name,
  sender_userpic: userpic,
  status: 'read',
  timestamp: new Date().toISOString(),
  type: 'message',
});

export default normalizeMessage;
